import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Navigate } from 'react-router-dom';
import projects from '../data/projects';
import { projectFooter } from '../utils/constants';
import '../css/project.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import ProjectCarousel from '../components/ProjectCarousel';

const ProjectShowcase = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const projectIndex = projects.findIndex((p) => p.id === id);
  const [isVisible, setIsVisible] = useState(false);
  // const [showBlurOverlays, setShowBlurOverlays] = useState(true);
  const [showHint, setShowHint] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const cycle = () => {
      if (!isMounted) return;

      setShowHint(true);
      setTimeout(() => {
        if (!isMounted) return;
        setShowHint(false);
      }, 5000);

      setTimeout(cycle, 15000);
    };

    const initialTimer = setTimeout(cycle, 10000);

    return () => {
      isMounted = false;
      clearTimeout(initialTimer);
    };
  }, []);

  useEffect(() => {
    setIsVisible(false);
    setTimeout(() => setIsVisible(true), 100);

    const applyScrollEffect = (container) => {
      if (!container) return;

      const handleScroll = () => {
        if (
          container.scrollHeight - container.scrollTop <=
          container.clientHeight + 1
        ) {
          container.classList.add('no-mask');
        } else {
          container.classList.remove('no-mask');
        }
      };

      container.addEventListener('scroll', handleScroll);
      handleScroll();

      return () => {
        container.removeEventListener('scroll', handleScroll);
      };
    };

    const containers = [
      document.querySelector('.overview-container'),
      document.querySelector('.features-container'),
      document.querySelector('.solutions-text-container'),
    ];

    containers.forEach((container) => applyScrollEffect(container));
  }, [id]);

  if (projectIndex === -1) {
    return <Navigate to='/404' replace />;
  }

  const project = projects[projectIndex];
  const images = project.images;

  const prevProject = projects[projectIndex - 1] || null;
  const nextProject = projects[projectIndex + 1] || null;

  const handlePrevClick = () =>
    prevProject && navigate(`/project-showcase/${prevProject.id}`);
  const handleNextClick = () =>
    nextProject && navigate(`/project-showcase/${nextProject.id}`);

  return (
    <div className='container'>
      <div className='header'>
        <p className='project-title aesthetic font-size-title reveal'>
          {projectIndex + 1}. {project.title}
        </p>
        <p className='aesthetic project-date'>Feb 2024</p>
      </div>

      <div className='content-body'>
        <div
          className={`nav nav-left ${!prevProject ? 'disabled-nav' : ''}`}
          onClick={handlePrevClick}
        >
          <p
            className={`aesthetic rotated-text font-size-title ${
              !prevProject ? 'disabled-btn' : ''
            }`}
          >
            PREVIOUS
          </p>
        </div>

        <div className='content-container'>
          <div className='content-left'>
            <div className='overview-container'>
              <h2 className='color font-size-title'>Overview</h2>
              <p className={`${isVisible ? 'fade-in' : 'fade-out'}`}>
                {project.overview}
              </p>
            </div>
            <div
              className={`screenshot-container ${
                isVisible ? 'fade-in' : 'fade-out'
              }`}
            >
              <ProjectCarousel images={images} />
            </div>
          </div>

          <div className='content-right'>
            <div className='features-container'>
              <p className={`${isVisible ? 'fade-in' : 'fade-out'} pl-10`}>
                {showHint && <div className='scroll-hint'>↓ Scroll</div>}
                {project.sections}
              </p>
              {/* {showBlurOverlays && (
                <>
                  <div className='blur blur-overlay-1'></div>
                  <div className='blur blur-overlay-2'></div>
                  <div className='blur blur-overlay-3'></div>
                </>
              )} */}
            </div>
            <div
              className={`tech-stack-container ${
                isVisible ? 'fade-in' : 'fade-out'
              }`}
            >
              {project.techStack.map((icon) => (
                <div className='tech-icon' key={icon.alt}>
                  <img src={icon.src} alt={icon.alt} loading='lazy' />
                  <span className='icon-tooltip aesthetic glow-text'>
                    {icon.alt}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div
          className={`nav nav-right ${!nextProject ? 'disabled-nav' : ''}`}
          onClick={handleNextClick}
        >
          <p
            className={`aesthetic rotated-text-right font-size-title ${
              !nextProject ? 'disabled-btn' : ''
            }`}
          >
            NEXT
          </p>
        </div>
      </div>

      <div className='footer'>
        {projectFooter.map((item, index) => (
          <div className='wrapper' key={index}>
            <div>
              <a
                href={item.link}
                rel='noopener noreferrer'
                className='aesthetic aesthetic-links hover-shadow hover-color hover-font font-color'
              >
                {[...item.name].map((char, i) => (
                  <span
                    key={i}
                    className='font-size-title'
                    style={{ color: '#fff' }}
                  >
                    {char}
                  </span>
                ))}
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProjectShowcase;
